import { t } from '@/i18n';
import { z } from 'zod';

export const modalFormSchema = z.object({
  team_uuid: z.string().optional(),
  urls: z
    .array(
      z.object({
        value: z
          .string()
          .min(1, t('pages.application_social_media.components.schema.required'))
          .url(t('pages.application_social_media.components.schema.invalid_url')),
      }),
    )
    .min(1, t('pages.application_social_media.components.schema.min_urls'))
    .max(5, t('pages.application_social_media.components.schema.max_urls')),
  enabled: z.boolean().default(true),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
